import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { FINDER_TOGGLES_COOKIE_NAME } from '@finder/shared/constants/app.constants';
import { safeJSONParse } from '@finder/shared/utils/object/safeJSONParse';

@Injectable({
    providedIn: 'root'
})
export class DebugCheckService {

    constructor(
        private cookieService: CookieService,
    ) {}

    isDebugEnabled() {
        const cookie = this.cookieService.get(FINDER_TOGGLES_COOKIE_NAME);
        const cookieValue = safeJSONParse(cookie);

        return cookieValue.debug === 'true' || cookieValue.debug === true;
    }
}
